import { Category } from '../types/bookmarks';

/**
 * Walks the parent_id chain from a given category up to root,
 * collecting names and returning them as a breadcrumb path.
 *
 * @param categoryId - The starting category ID (or null)
 * @param categories - The full list of categories
 * @returns A breadcrumb string like "Parent > Child > Grandchild", or "" if categoryId is null
 */
export function buildCategoryPath(
  categoryId: string | null,
  categories: Category[]
): string {
  if (categoryId === null) {
    return '';
  }

  const categoryMap = new Map<string, Category>();
  for (const cat of categories) {
    categoryMap.set(cat.category_id, cat);
  }

  const names: string[] = [];
  const visited = new Set<string>();
  let currentId: string | null = categoryId;

  while (currentId !== null) {
    if (visited.has(currentId)) {
      break; // Break circular parent_id chains
    }
    visited.add(currentId);

    const category = categoryMap.get(currentId);
    if (!category) {
      break; // Category not found in the list
    }

    names.push(category.category_name);
    currentId = category.parent_id;
  }

  names.reverse();
  return names.join(' > ');
}
